export const isFileSizeCorrect = (file: File, maxFileSize: number): boolean => {
  return file.size <= maxFileSize * 1000000;
};
